/** Pure unresolved Quiz progress rules shared by gameplay and durable persistence. */
export function isValidQuizItemProgressSequence(sequence: unknown): sequence is readonly number[] {
  if (!Array.isArray(sequence)) return false;
  const guesses = [...sequence];
  return (
    guesses.length <= 3 &&
    guesses.every((guess) => Number.isInteger(guess) && guess >= 1 && guess <= 3) &&
    new Set(guesses).size === guesses.length
  );
}

export function isSequencePrefix(prefix: readonly number[], sequence: readonly number[]): boolean {
  return (
    prefix.length <= sequence.length && prefix.every((value, index) => sequence[index] === value)
  );
}

/**
 * Reconcile an active client sequence against the durable unresolved fact.
 * A valid local extension is retained; stale or divergent local state yields
 * to the server checkpoint.
 */
export function reconcileQuizItemProgress(
  serverSequence: readonly number[],
  localSequence?: readonly number[]
): number[] {
  if (!localSequence || !isSequencePrefix(serverSequence, localSequence)) {
    return [...serverSequence];
  }
  return [...localSequence];
}
